import React from 'react';
import VerificationGoogle from '../../components/SecurityVerification/VerificationGoogle';

const GoogleAuthenticationPage = () => {
	return <VerificationGoogle />;
};

export default GoogleAuthenticationPage;
